import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { DashBoardParamList } from '../../../typings/Params';
import ActingBodiesDropdown from './ActingBodiesDropdown';
import ActingBodiesCommandsDropdown from '../../../components/Dropdowns/ActingBodiesCommandsDropdown';
import { TeamNameCategory } from '../../../schemas/dispatch';
import CategoriesDropdown from './CategoriesDropdown';
import ActingBodiesUnitsDropdown from '../../../components/Dropdowns/ActingBodiesUnitsDropdown';

interface Props {
    filters: DashBoardParamList['DashboardVehicles'];
    setFilters: React.Dispatch<React.SetStateAction<DashBoardParamList['DashboardVehicles']>>;
    authenticatedUser?: AuthenticatedUser | null;
    textFilter: string;
    setTextFilter: (value: string) => void;
}

function Filter({ authenticatedUser, filters, setFilters, textFilter, setTextFilter }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<DashBoardParamList, 'DashboardVehicles'>>>();

    const [actingBodyId, setActingBodyId] = useState<number>(filters.actingBodyId ?? 0);
    const [actingBodyUnitId, setActingBodyUnitId] = useState<number>(filters.actingBodyUnitId ?? 0);
    const [actingBodyCommandIds, setActingBodyCommandIds] = useState<number[]>(filters.actingBodyCommandIds ?? []);
    const [categoryList, setCategoryList] = useState<TeamNameCategory[]>(filters.categoryList ?? []);

    const handleCleanFilter = () => {
        setTextFilter('');
        setActingBodyId(0);
        setActingBodyUnitId(0);
        setActingBodyCommandIds([]);
        setCategoryList([]);
    };

    const handleFilter = () => {
        navigation.setParams({
            ...filters,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
            actingBodyUnitId: actingBodyUnitId !== 0 ? actingBodyUnitId : undefined,
            actingBodyCommandIds: actingBodyCommandIds.length ? actingBodyCommandIds : undefined,
            categoryList: categoryList.length ? categoryList : undefined
        });

        setFilters({
            ...filters,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
            actingBodyUnitId: actingBodyUnitId !== 0 ? actingBodyUnitId : undefined,
            actingBodyCommandIds: actingBodyCommandIds.length ? actingBodyCommandIds : undefined,
            categoryList: categoryList.length ? categoryList : undefined
        });
    };

    const getActingBodyId = () => {
        if (authenticatedUser?.isAdmin || authenticatedUser?.permissions.dashboard_see_vehicles_acting_bodies) {
            return actingBodyId;
        }
        return authenticatedUser?.actingBodyUnit.actingBodyId ?? 0;
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />

            <CategoriesDropdown value={categoryList} setValue={setCategoryList} zIndex={5} />

            {(authenticatedUser?.isAdmin || authenticatedUser?.permissions.dashboard_see_vehicles_acting_bodies) &&
                <ActingBodiesDropdown includeAllOption={true} value={actingBodyId} setValue={setActingBodyId} zIndex={4} />
            }

            {(authenticatedUser?.isAdmin || authenticatedUser?.permissions.dashboard_see_vehicles_acting_bodies || authenticatedUser?.permissions.dashboard_see_vehicles_acting_body_units) &&
                <ActingBodiesUnitsDropdown
                    actingBodyId={getActingBodyId()}
                    value={actingBodyUnitId}
                    setValue={setActingBodyUnitId}
                    zIndex={3} />
            }

            <ActingBodiesCommandsDropdown
                value={actingBodyCommandIds}
                actingBodyId={getActingBodyId()}
                setValue={setActingBodyCommandIds}
                zIndex={2}
            />

        </Filters>
    );
}


export default Filter;
